import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UnderConstruction.module.scss';
import constructionImage from '../../../assets/image/comingsoon01.png'; // 공사중 이미지

const UnderConstruction = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.constructionOverlay}>
      <div className={styles.constructionModal}>
        <img src={constructionImage} alt={t('common.underConstruction.imageAlt')} />
        <h2>{t('common.underConstruction.title')}</h2>
        <p>{t('common.underConstruction.body')}</p>
      </div>
    </div>
  );
};

export default UnderConstruction;
